import { render } from "./Author.vue?vue&type=template&id=ede49b6e&scoped=true"
import script from "./Author.vue?vue&type=script&lang=js"
export * from "./Author.vue?vue&type=script&lang=js"

import "./Author.vue?vue&type=style&index=0&id=ede49b6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede49b6e"]])

export default __exports__